import React, { useState } from "react";
import { createUser } from "./_request";
import { useAuth } from "../context/AuthContext";
import passeye from '../../assets/icons/passeye.svg';
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const CreateUser = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    role: "user",
    permissions: []
  });
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const { authToken } = useAuth();

  const roles = ["Admin", "User"];
  const permissionsList = ["Dashboard", "Home", "UserManagement", "Taaruf", "AboutSections", "FAQManagement", "Tazakraat", "Exhibition", "ExhibitionContent", "Munasibaat", "Tableghaat", "Noor-Diary", "Mujjalah", "Books", "Review-Tazakuraat", "ThemeManagement", "ClassForms", "namazTimings", "PostUpload", "PostApproval"];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePermissionChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      permissions: checked
        ? [...prevState.permissions, value]
        : prevState.permissions.filter((perm) => perm !== value)
    }));
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const response = await createUser(authToken, formData);
      if (response.Result) {
        alert("User created successfully!");
        setFormData({
          email: "",
          password: "",
          role: "user",
          permissions: []
        })
      }
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/users')}
        className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-3"
      >
        Go Back
      </Button>
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Create User</h2>

        <form onSubmit={handleCreate} className="space-y-4">
          <div>
            <label className="block text-sm font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-2 border rounded"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full p-2 border rounded pr-10"
                required
              />
              <button
                type="button"
                className="absolute inset-y-0 right-2 flex items-center"
                onClick={() => setShowPassword(!showPassword)}
              >
                <img src={passeye} alt="Toggle Password Visibility" className="w-5 h-5" />
              </button>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium">Role</label>
            <Select
              value={formData.role}
              onChange={handleChange}
              fullWidth
            >
              <MenuItem value="">Select...</MenuItem>
              {roles.map((role) => (
                <MenuItem key={role} value={role.toLowerCase()}>
                  {role}
                </MenuItem>
              ))}
            </Select>
          </div>
          <div>
            <label className="block text-sm font-medium">Permissions</label>
            <div className="grid grid-cols-2 gap-2">
              {permissionsList.map((perm) => (
                <label key={perm} className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    value={perm}
                    checked={formData.permissions.includes(perm)}
                    onChange={handlePermissionChange}
                  />
                  <span>{perm}</span>
                </label>
              ))}
            </div>
          </div>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
          >
            Create User
          </Button>
        </form>
      </div>
    </div>
  );
};

export default CreateUser;
